// Resolves a blog post author into an avatar element. Order:
//   1. author.imgSrc → photo
//   2. author.logo === "scribenote" → purple SN gradient puck (matches the
//      "The Scribenote Team" treatment on the Getting Started hero)
//   3. post mascot → mascot SVG inside an indigo puck
//   4. otherwise → null
import type { BlogAuthor } from "./posts";
import { Mascot, type MascotName } from "../../components/Mascot";

type AuthorAvatarProps = {
  author: BlogAuthor;
  mascot?: MascotName;
  size?: number;
};

export function AuthorAvatar({ author, mascot, size = 28 }: AuthorAvatarProps) {
  const dim = `${size}px`;

  if (author.imgSrc) {
    return (
      <img
        src={author.imgSrc}
        alt=""
        width={size}
        height={size}
        className="block rounded-full object-cover"
        style={{ width: dim, height: dim }}
      />
    );
  }

  if (author.logo === "scribenote") {
    return (
      <div
        aria-hidden="true"
        className="font-companion grid shrink-0 place-items-center rounded-full bg-[linear-gradient(135deg,#6366F1_0%,#818CF8_100%)] font-bold tracking-[0.02em] text-white shadow-[0_4px_12px_-4px_rgba(99,102,241,0.5)]"
        style={{
          width: dim,
          height: dim,
          fontSize: `${Math.max(10, Math.round(size * 0.42))}px`,
        }}
      >
        SN
      </div>
    );
  }

  if (mascot) {
    return (
      <div
        className="grid place-items-center overflow-hidden rounded-full bg-indigo-50"
        style={{ width: dim, height: dim }}
      >
        <Mascot name={mascot} size={Math.round(size * 0.92)} />
      </div>
    );
  }

  return null;
}
